// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import './index.css'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import moment from 'moment';
import Dialog from 'material-ui/Dialog';
import DatePicker from 'react-datepicker';
import { colors, btn, card, form } from '../../../../style/common/partnerStyle';
// import { FileUploader } from "react-drag-drop-files";


const fileTypes = ["JPG", "PNG", "GIF"];

// ─── Image compression ───────────────────────────────────────────────────────
// Compresses an image File using Canvas.
// If the compressed output is larger than the original, the original is returned.
function compressImage(file, { maxWidth = 1920, maxHeight = 1080, quality = 0.82 } = {}) {
  return new Promise((resolve) => {
    // Skip: non-image or animated GIF
    if (!file.type.startsWith('image/') || file.type === 'image/gif') {
      return resolve(file);
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        let { width, height } = img;

        // Scale down if needed, preserving aspect ratio
        if (width > maxWidth || height > maxHeight) {
          const ratio = Math.min(maxWidth / width, maxHeight / height);
          width  = Math.round(width  * ratio);
          height = Math.round(height * ratio);
        }

        const canvas  = document.createElement('canvas');
        canvas.width  = width;
        canvas.height = height;
        canvas.getContext('2d').drawImage(img, 0, 0, width, height);

        // PNG → JPEG conversion gives the best size reduction
        const outputType = file.type === 'image/png' ? 'image/jpeg' : file.type;

        canvas.toBlob(
          (blob) => {
            if (!blob) return resolve(file); // fallback on canvas failure
            if (blob.size >= file.size) return resolve(file); // keep original if no gain
            resolve(new File([blob], file.name.replace(/\.\w+$/, '') + (outputType === 'image/jpeg' ? '.jpg' : ''), {
              type: outputType,
              lastModified: Date.now(),
            }));
          },
          outputType,
          quality,
        );
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  });
}

function formatBytes(bytes) {
  if (bytes < 1024)        return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
// ─────────────────────────────────────────────────────────────────────────────


class AddCompetitionGallery extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      photo_list: [],
      selected_album_id:   this.props.album.id          ? this.props.album.id          : '',
      selected_album_name: this.props.album.name        ? this.props.album.name        : '',
      competition_id:  props.competition_id,
      to_go_back:      props.add_photos_visible,
      venues: [],
      game_types: [],
      sub_categories: [],
      data_uploaded: false,
      data_error:    false,
      addGalleryView: false,
      add_photos_visible: true,
      to_delete_photo: false,
      gallery_details: {
        competition_id: props.competition_id,
        name: '',
        description: '',
        cover_photo: '',
        fb_album_id: '',
        fb_album_url: '',
        venue: '',
        sub_category: '',
        photo: '',
        disabled: false,
      },

      // Each entry: { file, preview, originalSize, compressedSize, compressing }
      selected_files: [],
      any_compressing: false, // true while at least one file is still being compressed

      updating:        false,
      upload_progress: 0,     // 0–100
      disabled:        false,
      album_description: this.props.album.description ? this.props.album.description : '',
      is_video: false,
    };
    this.handleChange     = this.handleChange.bind(this);
    this.getPhotosInAlbum = this.getPhotosInAlbum.bind(this);
    this.onPhotoSelect    = this.onPhotoSelect.bind(this);
    this.updateAlbum      = this.updateAlbum.bind(this);
    this.handleSubmit     = this.handleSubmit.bind(this);
    this.createAlbum      = this.createAlbum.bind(this);
  }

  componentDidMount() {
    this.getPhotosInAlbum();
    console.log(this.state);
  }

  getPhotosInAlbum() {
    const url = `${getLocationOrigin()}/tournament/get_photos/?album_id=${this.state.selected_album_id}`;
    const options = {...defaultOptions};
    options['method'] = 'get';
    options['headers'] = {'content-type': 'application/json'};
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then(data => this.setState({ photo_list: data.photos }))
      .catch(error => { console.log(error); alert(error.message); });
  }

  deletePhotos(photo_id) {
    this.setState({ to_delete_photo: true });
    const url = `${getLocationOrigin()}/tournament/delete_photos/?photo_id=${photo_id}`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'};
    options['body'] = JSON.stringify({ photo_id });
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .catch(error => { console.log(error); alert(error.message); this.setState({ to_delete_photo: false }); })
      .then(data => { alert(data.message); this.setState({ to_delete_photo: false }); window.location.reload(); });
  }

  postaddGallery(data, props) {
    console.log(data);
    if(!data.sub_category) { data.sub_category = this.state.sub_categories[0][0]; }
    if(!data.venue)        { data.venue        = this.state.venues[0].id; }
    console.log(data);
    const url = `${getLocationOrigin()}/tournament/add_competition_gallery/`;
    const options = {...defaultOptions};
    var formData = new FormData();
    for(var name in data) { formData.append(name, data[name]); }
    options['method'] = 'post';
    options['body'] = formData;
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then((response) => { alert(response.message); this.setState({ addGalleryView: false }); })
      .catch(error => { console.log(error); alert(error.message); });
  }

  handleChange(event) {
    const value = event.target.value;
    if(event.target.name === 'album_description') { this.setState({ album_description: value }); }
    else { this.setState({ selected_album_name: value }); }
  }

  // ── File selection + async compression ─────────────────────────────────────
  async onPhotoSelect(selectorFiles) {
    const newFiles = Array.from(selectorFiles);
    if (!newFiles.length) return;

    const isVideo = this.state.is_video;

    // Build placeholder entries immediately for instant feedback
    const placeholders = newFiles.map(file => ({
      file,
      preview:        isVideo ? null : URL.createObjectURL(file),
      originalSize:   file.size,
      compressedSize: null,
      compressing:    !isVideo,
    }));

    this.setState(prev => ({
      selected_files:  [...prev.selected_files, ...placeholders],
      any_compressing: !isVideo,
    }));

    if (isVideo) return; // no compression for videos

    // Compress all new files in parallel
    const compressed = await Promise.all(newFiles.map(f => compressImage(f)));

    this.setState(prev => {
      const updated = [...prev.selected_files];
      const offset  = updated.length - newFiles.length;
      compressed.forEach((compressedFile, i) => {
        // Revoke old object URL before replacing
        if (updated[offset + i].preview) URL.revokeObjectURL(updated[offset + i].preview);
        updated[offset + i] = {
          ...updated[offset + i],
          file:           compressedFile,
          preview:        URL.createObjectURL(compressedFile),
          compressedSize: compressedFile.size,
          compressing:    false,
        };
      });
      return {
        selected_files:  updated,
        any_compressing: updated.some(f => f.compressing),
      };
    });
  }

  removeSelectedFile(index) {
    this.setState(prev => {
      const updated = [...prev.selected_files];
      if (updated[index].preview) URL.revokeObjectURL(updated[index].preview);
      updated.splice(index, 1);
      return {
        selected_files:  updated,
        any_compressing: updated.some(f => f.compressing),
      };
    });
  }

  add_photos_visible() { this.setState({ add_photos_visible: true }); }

  updatedata(formData) {
    const url = `${getLocationOrigin()}/tournament/update_album/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['body'] = formData;
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then((response) => {
        console.log(response);
        this.setState({ selected_album_id: response.album_id, selected_files: [] }, () => {
          this.props.ParentCallback({ to_go_back: this.state.to_go_back });
        });
      })
      .catch(error => { console.log(error); alert(error.message); });
  }

  createAlbum(name, formData) {
    const url = `${getLocationOrigin()}/gallery/create_album/?name=${name}`;
    const options = {...defaultOptions};
    options['method'] = 'get';
    options['headers'] = {'content-type': 'application/json'};
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then(data => {
        this.setState({ selected_album_id: data.id }, () => {
          formData.append("album_id", this.state.selected_album_id);
          for(let i = 0; i < this.state.selected_files.length; i++) {
            if(!this.state.is_video) { formData.append("photo", this.state.selected_files[i].file); }
            else                    { formData.append("video", this.state.selected_files[i].file); }
            this.updateAlbum(formData, i);
          }
        });
      })
      .catch(error => { console.log(error); alert(error.message); });
  }

  updateAlbum(formData, i) {
    const url = `${getLocationOrigin()}/tournament/update_album/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['body'] = formData;
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then(() => {
        const total = this.state.selected_files.length || 1;
        const done  = i + 1;
        this.setState({ upload_progress: Math.round((done / total) * 100) });
        if (done === total) { window.location.reload(); }
      })
      .catch(error => { console.log(error); alert(error.message); });
  }

  handleSubmit() {
    if (this.state.any_compressing) {
      alert('Please wait — images are still being compressed.');
      return;
    }
    this.setState({ disabled: true, updating: true, upload_progress: 0 });
    var formData = new FormData();
    formData.append("competition_id", this.props.competition_id);
    if(this.state.selected_album_name) { formData.append("name", this.state.selected_album_name); }
    formData.append("description", this.state.album_description);
    if(this.state.selected_album_id) {
      formData.append("album_id", this.state.selected_album_id);
      if(this.state.selected_files.length > 0) {
        for(var i = 0; i < this.state.selected_files.length; i++) {
          formData.append("photo", this.state.selected_files[i].file);
          this.updateAlbum(formData, i);
        }
      }
      else { this.updateAlbum(formData, 0); }
    }
    else { this.createAlbum(this.state.selected_album_name, formData); }
  }

  render() {
    const {
      selected_album_name, album_description, is_video,
      photo_list, selected_files, updating, disabled,
      any_compressing, upload_progress,
    } = this.state;

    const totalOriginal   = selected_files.reduce((s, f) => s + f.originalSize, 0);
    const totalCompressed = selected_files.reduce((s, f) => s + (f.compressedSize != null ? f.compressedSize : f.originalSize), 0);
    const savedBytes      = Math.max(0, totalOriginal - totalCompressed);
    const savedPct        = totalOriginal > 0 ? Math.round((savedBytes / totalOriginal) * 100) : 0;

    return (
      <div style={{ fontFamily: "'DM Sans', 'Segoe UI', sans-serif", background: colors.bg, padding: '24px 20px', boxSizing: 'border-box' }}>
        <div style={{ maxWidth: 800, margin: '0 auto' }}>
          <div style={{ background: colors.surface, borderRadius: 12, boxShadow: '0 1px 4px rgba(0,0,0,0.08), 0 4px 16px rgba(0,0,0,0.06)', overflow: 'hidden' }}>

            {/* Header */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '18px 24px', borderBottom: `1px solid ${colors.border}` }}>
              <h2 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: colors.text }}>
                {selected_album_name ? `Album: ${selected_album_name}` : 'New Album'}
              </h2>
              <button style={btn.outline} onClick={() => this.props.ParentCallback({ to_go_back: this.state.to_go_back })}>← Back</button>
            </div>

            <div style={{ padding: '20px 24px' }}>

              {/* Album Name */}
              <div style={form.row}>
                <div style={form.labelWide}>Album Name</div>
                <input type="text" name="album_name" style={form.input} value={selected_album_name} onChange={this.handleChange} placeholder="Album Name" />
              </div>

              {/* Album Description */}
              <div style={form.row}>
                <div style={form.labelWide}>Description</div>
                <textarea name="album_description" style={{ ...form.textarea, minHeight: 70 }} value={album_description} onChange={this.handleChange} placeholder="Album description…" rows={3} />
              </div>

              {/* File type toggle */}
              <div style={form.row}>
                <div style={form.labelWide}>File Type</div>
                <div style={{ display: 'flex', gap: 8 }}>
                  <button type="button" style={!is_video ? btn.primary : btn.outline} onClick={() => this.setState({ is_video: false })}>📷 Photos</button>
                  <button type="button" style={is_video  ? btn.primary : btn.outline} onClick={() => this.setState({ is_video: true  })}>🎬 Videos</button>
                </div>
              </div>

              {/* Drop-zone style file input */}
              <div style={form.row}>
                <div style={form.labelWide}>{is_video ? 'Add Videos' : 'Add Photos'}</div>
                <div style={{ flex: 1 }}>
                  <label
                    style={{
                      display: 'flex', flexDirection: 'column', alignItems: 'center',
                      justifyContent: 'center', gap: 6, padding: '18px 16px',
                      border: `2px dashed ${colors.border}`, borderRadius: 10,
                      cursor: 'pointer', background: colors.bg, transition: 'border-color 0.15s',
                    }}
                    onMouseEnter={e => e.currentTarget.style.borderColor = colors.brand}
                    onMouseLeave={e => e.currentTarget.style.borderColor = colors.border}
                  >
                    <span style={{ fontSize: 26 }}>{is_video ? '🎬' : '🖼️'}</span>
                    <span style={{ fontSize: 13, fontWeight: 600, color: colors.text }}>
                      Click to select {is_video ? 'videos' : 'photos'}
                    </span>
                    <span style={{ fontSize: 11, color: colors.muted }}>
                      Multiple files supported{!is_video ? ' · Auto-compressed before upload' : ''}
                    </span>
                    <input
                      multiple
                      type="file"
                      name="photo"
                      accept={is_video ? 'video/*' : 'image/*'}
                      style={{ display: 'none' }}
                      onChange={(e) => this.onPhotoSelect(e.target.files)}
                    />
                  </label>

                  {/* Compression summary */}
                  {!is_video && selected_files.length > 0 && !any_compressing && savedBytes > 0 && (
                    <div style={{ marginTop: 8, display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, color: colors.success, fontWeight: 600 }}>
                      <span>✓</span>
                      <span>Saved {formatBytes(savedBytes)} ({savedPct}% smaller across {selected_files.length} image{selected_files.length > 1 ? 's' : ''})</span>
                    </div>
                  )}
                  {any_compressing && (
                    <div style={{ marginTop: 8, fontSize: 12, color: colors.brand, fontWeight: 600 }}>
                      ⏳ Compressing images…
                    </div>
                  )}
                </div>
              </div>

              {/* New files preview grid */}
              {selected_files.length > 0 && (
                <div style={{ marginBottom: 20 }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
                    <span style={{ fontSize: 12, fontWeight: 600, color: colors.muted, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                      Queued for Upload ({selected_files.length})
                    </span>
                    <button
                      type="button"
                      onClick={() => {
                        selected_files.forEach(f => f.preview && URL.revokeObjectURL(f.preview));
                        this.setState({ selected_files: [], any_compressing: false });
                      }}
                      style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 12, color: colors.danger, fontFamily: 'inherit', fontWeight: 600 }}
                    >
                      Clear all
                    </button>
                  </div>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
                    {selected_files.map((item, index) => (
                      <div key={index} style={{ position: 'relative', width: 106 }}>
                        {/* Thumbnail */}
                        <div style={{ width: 106, height: 106, borderRadius: 8, overflow: 'hidden', background: colors.bg, border: `1px solid ${colors.border}`, position: 'relative' }}>
                          {is_video ? (
                            <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 32 }}>🎬</div>
                          ) : item.preview ? (
                            <img src={item.preview} style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} alt="" />
                          ) : null}
                          {/* Compressing overlay */}
                          {item.compressing && (
                            <div style={{ position: 'absolute', inset: 0, background: 'rgba(255,255,255,0.75)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20 }}>⏳</div>
                          )}
                        </div>
                        {/* Remove button */}
                        <button
                          type="button"
                          style={{ position: 'absolute', top: 4, right: 4, width: 20, height: 20, borderRadius: '50%', background: 'rgba(224,36,36,0.9)', color: '#fff', border: 'none', cursor: 'pointer', fontSize: 11, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'inherit' }}
                          onClick={() => this.removeSelectedFile(index)}
                        >×</button>
                        {/* Filename + size info */}
                        <div style={{ marginTop: 4, fontSize: 10, color: colors.muted, lineHeight: 1.35 }}>
                          <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 106 }} title={item.file.name}>
                            {item.file.name}
                          </div>
                          {!is_video && !item.compressing && item.compressedSize != null && (
                            item.compressedSize < item.originalSize ? (
                              <span style={{ color: colors.success, fontWeight: 600 }}>
                                {formatBytes(item.compressedSize)}{' '}
                                <span style={{ color: colors.muted, fontWeight: 400 }}>
                                  ↓{formatBytes(item.originalSize)}
                                </span>
                              </span>
                            ) : (
                              <span>{formatBytes(item.originalSize)} <span style={{ color: colors.muted }}>(no gain)</span></span>
                            )
                          )}
                          {!is_video && item.compressing && <span style={{ color: colors.brand }}>compressing…</span>}
                          {is_video && <span>{formatBytes(item.originalSize)}</span>}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Existing photos grid */}
              {photo_list.length > 0 && (
                <div style={{ marginBottom: 20 }}>
                  <div style={{ fontSize: 12, fontWeight: 600, color: colors.muted, textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 10 }}>
                    Existing Photos ({photo_list.length})
                  </div>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
                    {photo_list.map((photo, index) => (
                      <div key={index} style={{ position: 'relative', width: 106, height: 106, borderRadius: 8, overflow: 'hidden', background: colors.bg, border: `1px solid ${colors.border}` }}>
                        <img src={photo.image} style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
                        {photo.id && (
                          <button
                            style={{ position: 'absolute', top: 4, right: 4, width: 22, height: 22, borderRadius: '50%', background: 'rgba(224,36,36,0.9)', color: '#fff', border: 'none', cursor: 'pointer', fontSize: 13, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'inherit' }}
                            onClick={() => { this.deletePhotos(photo.id); }}
                          >×</button>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Upload progress bar */}
              {updating && (
                <div style={{ marginBottom: 16 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, fontWeight: 600, color: colors.brand, marginBottom: 6 }}>
                    <span>⏳ Uploading…</span>
                    <span>{upload_progress}%</span>
                  </div>
                  <div style={{ height: 6, background: colors.border, borderRadius: 99, overflow: 'hidden' }}>
                    <div style={{ height: '100%', width: `${upload_progress}%`, background: colors.brand, borderRadius: 99, transition: 'width 0.3s ease' }} />
                  </div>
                </div>
              )}

              {/* Footer */}
              <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', paddingTop: 16, borderTop: `1px solid ${colors.border}`, marginTop: 8 }}>
                <button type="button" style={btn.cancel} onClick={() => this.props.ParentCallback({ to_go_back: this.state.to_go_back })}>Cancel</button>
                <button
                  type="button"
                  style={{ ...btn.primary, opacity: (disabled || any_compressing) ? 0.6 : 1, cursor: (disabled || any_compressing) ? 'not-allowed' : 'pointer' }}
                  disabled={disabled || any_compressing}
                  onClick={() => this.handleSubmit()}
                >
                  {any_compressing ? 'Compressing…' : updating ? `Uploading ${upload_progress}%…` : 'Update Album'}
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddCompetitionGallery;


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/addCompetitionGallery/index.js